import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const Import3044Page = createLazyPage(
  () => import('@app/modules/legalReports/pages/Import3044Page')
);

const Export3044Page = createLazyPage(
  () => import('@app/modules/legalReports/pages/Export3044Page')
);

const Legal3044ValidationReportPage = createLazyPage(
  () => import('@app/modules/legalReports/pages/Legal3044ValidationReportPage')
);

export const legalReportRoutes: AppRouteDefinition[] = [
  {
    key: 'legalreports-import-cadoc3044',
    path: 'LegalReports/Import/Cadoc3044',
    element: <Import3044Page />,
  },
  {
    key: 'legalreports-generate-cadoc3044',
    path: 'LegalReports/Generate/Cadoc3044',
    element: <Export3044Page />,
  },
  {
    key: 'legalreports-validationreport-cadoc3044',
    path: 'LegalReports/ValidationReport/Cadoc3044',
    element: <Legal3044ValidationReportPage />,
  },
];
